import { EntityState } from '@ngrx/entity';
import { UserEmailEntity } from '../entities';

export interface UserEmailState extends EntityState<UserEmailEntity> {
  isLoading: boolean;
  isLoaded: boolean;
}
